import { Stop } from "@mui/icons-material";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import { useArgonController } from "context";
import { NavLink } from "react-router-dom";
import { collapseChildIcon, collapseChildIconBox, collapseChildItem, collapseText } from "./styles/sidenavCollapse";

const SidenavChild = ({ color, name, active, route }) => {
    const [controller] = useArgonController();
    const { miniSidenav, darkSidenav, darkMode } = controller;
    return (
        <ListItem component="li">
            <NavLink to={route}>
                <ArgonBox sx={(theme) => collapseChildItem(theme, { active, darkSidenav, darkMode })}>
                    <ListItemIcon
                        sx={(theme) => collapseChildIconBox(theme, { active, darkSidenav, color, darkMode })}
                    >
                        <Stop sx={(theme) => collapseChildIcon(theme, { active })} />
                    </ListItemIcon>
                    <ListItemText
                        primary={name}
                        sx={(theme) => collapseText(theme, { miniSidenav, darkSidenav, active })}
                    />
                </ArgonBox>
            </NavLink>
        </ListItem>
    )
}

SidenavChild.propTypes = {}

export default SidenavChild